function SkeletonCard() {
  return (
    <div className="compact-skeleton-card">
      <div className="skeleton-top">
        <span />
        <div>
          <b />
          <b />
        </div>
      </div>

      <div className="skeleton-progress" />
    </div>
  );
}

export default SkeletonCard;